'use strict';

function mediumzoomFunction(g) {
  function zoomPicture() {
    mediumZoom('.medium-zoomable, .wp-block-media-text img, figure img, li:not(.blocks-gallery-item) figure img', {
      margin: 25
    });
  };

  function init() {
    zoomPicture();
  }

  init();
}
